<template>
  <modal-component
    :is-displayed="isReassignModalOpened"
    custom-modal-size="w-3/12"
    :title="$t('ICDManagement.ReassignModalHeading')"
    @toggle-modal="$emit('toggle-modal')"
    @execute-method="$emit('reassign-action')"
  >
    <div>
      <div class="flex w-full flex-col items-center justify-center">
        <div class="flex h-24 w-24 items-center justify-center rounded-full bg-primarylighthover">
          <font-awesome-icon :icon="['fas', 'triangle-exclamation']" class="text-4xl text-primary" />
        </div>
        <div class="flex flex-col gap-2 pb-8 pt-4 text-center">
          <h2 class="text-lg font-medium">
            {{ $t("ICDManagement.ReassignModalAlreadyAssigned") + " " + customer.name }}
          </h2>
          <p class="text-sm">
            {{ $t("ICDManagement.ReassignModalAreYouSure") }}
            tag?
          </p>
        </div>
      </div>
      <div class="flex gap-2 px-6">
        <the-button
          :full-width="true"
          button-type="primaryButton"
          :text="$t('ICDManagement.Reassign')"
          @execute-method="$emit('reassign-action')"
        />
        <the-button
          :full-width="true"
          button-type="oulineButton"
          :text="$t('General.Cancel')"
          @execute-method="$emit('toggle-modal')"
        />
      </div>
    </div>
  </modal-component>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import ModalComponent from "@/core/Components/Modal.vue";
import TheButton from "@/core/Components/TheButton.vue";

export default defineComponent({
  components: { TheButton, ModalComponent },
  props: {
    isReassignModalOpened: Boolean,
    customer: {
      type: Object,
      required: true,
    },
  },
  emits: ["toggle-modal", "reassign-action"],
});
</script>

<style scoped></style>
